module.exports = __webpack_public_path__ + "static/media/calendar.8da9ddef.svg";